import {Component, OnInit} from '@angular/core';
import {
  ERROR_CODE_CHECKOUT_UNAVAILABLE,
  ERROR_CODE_CUSTOMER_HAS_ALREADY_CPEA,
  ERROR_CODE_CUSTOMER_HAS_ALREADY_PAYG,
  ERROR_CODE_PRODUCT_NOT_ALLOWED_B2I,
  ERROR_CODE_RESTRUCTURE
} from '@app/checkout/services/cart-decorator-error-handling.service';
import {ActivatedRoute} from '@angular/router';
import {first, map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {ConfigureUrlErrorService} from '../../services/configure-url-error.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'dcp-configure-url-error',
  templateUrl: './configure-url-error.component.html',
  styleUrls: ['./configure-url-error.component.scss']
})
export class ConfigureUrlErrorComponent implements OnInit {

  errorCode$: Observable<string>;
  b2i = ERROR_CODE_PRODUCT_NOT_ALLOWED_B2I; // VAL_0301
  cpea = ERROR_CODE_CUSTOMER_HAS_ALREADY_CPEA; // VAL_0302
  payg = ERROR_CODE_CUSTOMER_HAS_ALREADY_PAYG; // VAL_0303
  unavailable = ERROR_CODE_CHECKOUT_UNAVAILABLE; // VAL_0304
  restructure = ERROR_CODE_RESTRUCTURE; // VAL_0305

  constructor(
    private route: ActivatedRoute,
    private configureUrlErrorService: ConfigureUrlErrorService
  ) {
  }

  ngOnInit() {
    this.errorCode$ = this.route.paramMap.pipe(
      first(),
      map(code => code.get('errorCode')),
      untilDestroyed(this)
    );
    this.configureUrlErrorService.setProductsFromUrl();
  }
}
